// First-party, cookieless analytics client. Fires pageviews and custom events to
// our own API (`POST /analytics/collect`). No cookies, no third parties, no PII:
// the server derives an anonymous daily hash + coarse geo from the request and
// never stores a raw IP. We only send the current path, external referrer, a
// per-tab session id, and a screen-size bucket.

const API_BASE = process.env.REACT_APP_API || '';

const getSessionId = () => {
  try {
    let sid = sessionStorage.getItem('ep_sid');
    if (!sid) {
      sid =
        (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID()) ||
        `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      sessionStorage.setItem('ep_sid', sid);
    }
    return sid;
  } catch (e) {
    return '';
  }
};

const screenBucket = () => {
  try {
    return `${window.screen?.width || 0}x${window.screen?.height || 0}`;
  } catch (e) {
    return '';
  }
};

// First-party attribution: read any captured UTM/promo/ref from sessionStorage
// so every event carries where the visitor came from. No third-party, no cookies.
const attribution = () => {
  try {
    const raw = sessionStorage.getItem('ep_utm');
    const utm = raw ? JSON.parse(raw) : {};
    const promo = sessionStorage.getItem('ep_promo') || '';
    const ref = sessionStorage.getItem('ep_ref') || '';
    return { ...utm, ...(promo ? { promo } : {}), ...(ref ? { ref } : {}) };
  } catch (e) {
    return {};
  }
};

const send = (payload) => {
  if (!API_BASE) return;
  try {
    fetch(`${API_BASE}/analytics/collect`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
      credentials: 'omit',
    }).catch(() => {});
  } catch (e) {
    /* analytics must never break the site */
  }
};

export const trackPageview = (path) => {
  send({
    type: 'pageview',
    path: path || window.location.pathname,
    referrer: document.referrer || '',
    sessionId: getSessionId(),
    screen: screenBucket(),
  });
};

export const trackEvent = (name, meta = {}) => {
  send({
    type: 'event',
    name,
    path: window.location.pathname,
    referrer: document.referrer || '',
    sessionId: getSessionId(),
    screen: screenBucket(),
    meta: { ...attribution(), ...meta },
  });
};
